/* eslint-disable react-hooks/exhaustive-deps */
import { FC } from 'react'
import styled from 'styled-components'
import ActionButton from 'components/ActionButton'
import {
  ModalActions,
  ModalCard,
  ModalMessage,
  ModalOverlay,
  ModalTitle
} from 'components/modals/styles'

const Overlay = styled(ModalOverlay)`
  z-index: 10011;
`

const Card = styled(ModalCard)`
  width: 350px;
  max-width: 800px;
  border-radius: 8px;
`

const Header = styled.div`
  margin-bottom: 10px;
`

const Body = styled.div`
  margin-bottom: 14px;
`

const Footer = styled(ModalActions)``

interface Props {
  show: boolean
  onClose: () => void
}
const PauseConfirmationModal: FC<Props> = (props) => {
  const { onClose, show } = props

  if (!show) return null

  return (
    <Overlay onClick={onClose}>
      <Card
        role='dialog'
        aria-modal='true'
        aria-labelledby='pause-confirmation-modal-title'
        onClick={(event) => event.stopPropagation()}
      >
        <Header>
          <ModalTitle id='pause-confirmation-modal-title'>
            Your Test Session Is Paused.
          </ModalTitle>
        </Header>
        <Body>
          <ModalMessage>
            To resume testing, click the Resume button.
          </ModalMessage>
        </Body>
        <Footer>
          <ActionButton
            label='Resume'
            variant='success'
            width={92}
            onClick={onClose}
          />
        </Footer>
      </Card>
    </Overlay>
  )
}

export default PauseConfirmationModal
